import RedirectHelper from '../../../components/RedirectHelper';

const RequestNewPassword = (): JSX.Element => {
  RedirectHelper.redirectToUserManagement('/forgot-password');
  return <></>;
};

export default RequestNewPassword;
